module.exports = __webpack_public_path__ + "assets/bell-icon-white.c58bf7aa.svg";